import { render, staticRenderFns } from "./ApartmentForm.vue?vue&type=template&id=f1aa61ae"
import script from "./ApartmentForm.vue?vue&type=script&lang=ts"
export * from "./ApartmentForm.vue?vue&type=script&lang=ts"
import style0 from "./ApartmentForm.vue?vue&type=style&index=0&id=f1aa61ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports